import React from 'react';
import useHabitatInsightsUpload from 'src/app/habitat-insights/views/habitat-insights-details/components/habitat-insights-upload/hooks/useHabitatInsightsUpload';
import ErrorMessage from 'src/shared/components/error-msg/ErrorMessage';
import SuccessMessage from 'src/shared/components/success-message/SuccessMessage';
import HabitatInsightsSamplesUpload from './components/habitat-insights-samples-upload/HabitatInsightsSamplesUpload';

export const HabitatInsightsSamples = () => {
    const { formState } = useHabitatInsightsUpload();

    const { uploadedFileErrors, uploadedFileContent } = formState;

    return (
        <div className='w-[720px] flex flex-col'>
            <HabitatInsightsSamplesUpload />
            <div className='mt-[50px]'>
                {uploadedFileContent.length > 0 ? (
                    uploadedFileErrors.length > 0 ? (
                        <ul>
                            {uploadedFileErrors.map((error, index) => (
                                <ErrorMessage key={index} message={<span dangerouslySetInnerHTML={{ __html: error.message }} />} />
                            ))}
                        </ul>
                    ) : (
                        <SuccessMessage message={'Data successfully uploaded with no errors'} />
                    )
                ) : null}
            </div>
        </div>
    );
};

export default HabitatInsightsSamples;
